import React from 'react'

const CloseIcon = () => {
    return (
        <>
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.7752 5.23417C16.4177 4.87667 15.8402 4.87667 15.4827 5.23417L11.0002 9.7075L6.51766 5.225C6.16016 4.8675 5.58266 4.8675 5.22516 5.225C4.86766 5.5825 4.86766 6.16 5.22516 6.5175L9.70766 11L5.22516 15.4825C4.86766 15.84 4.86766 16.4175 5.22516 16.775C5.58266 17.1325 6.16016 17.1325 6.51766 16.775L11.0002 12.2925L15.4827 16.775C15.8402 17.1325 16.4177 17.1325 16.7752 16.775C17.1327 16.4175 17.1327 15.84 16.7752 15.4825L12.2927 11L16.7752 6.5175C17.1235 6.16917 17.1235 5.5825 16.7752 5.23417Z" fill="#06152D"/>
            </svg>
        </>
    )
}

export default CloseIcon